/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PreviewMaterialItemDto = {
  /**
   * 예습자료 타입 (YOUTUBE / PDF / IMAGE)
   */
  type: PreviewMaterialItemDto.type;
  /**
   * 유튜브 영상 길이 타입 (LONGFORM / SHORTFORM)
   */
  format?: PreviewMaterialItemDto.format;
  /**
   * URL — 영상(YOUTUBE) 또는 파일(PDF/IMAGE) S3 URL
   */
  url: string;
  /**
   * 원본 파일명 (PDF/IMAGE 표시용)
   */
  fileName?: string;
  /**
   * 썸네일 URL
   */
  thumbnailUrl?: string;
  /**
   * 영상 길이(초) — 표시용
   */
  durationSeconds?: number;
};
export namespace PreviewMaterialItemDto {
  /**
   * 예습자료 타입 (YOUTUBE / PDF / IMAGE)
   */
  export enum type {
    YOUTUBE = "YOUTUBE",
    PDF = "PDF",
    IMAGE = "IMAGE",
  }
  /**
   * 유튜브 영상 길이 타입 (LONGFORM / SHORTFORM)
   */
  export enum format {
    LONGFORM = "LONGFORM",
    SHORTFORM = "SHORTFORM",
  }
}
